import { render, staticRenderFns } from "./BaseSearchDetails.vue?vue&type=template&id=401d3ccb&"
import script from "./BaseSearchDetails.vue?vue&type=script&lang=js&"
export * from "./BaseSearchDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports